import { createSlice } from '@reduxjs/toolkit'

export const initialData = {
    objectFormData:{},
    allForms:[],
    questore:"",
    filestore:false,
    answerAgreedDataSet:"",
    discussionLogDataSet:"",
    citationsDataSet:"",
    loadingStatus : null,
    stopApiCall:false
};

const aiWebSearchData = createSlice({
  name: 'aiWebSearchData',
  initialState: initialData,
  reducers: {
    aiWebSearchdataAdd(state, action) {
      state.allForms.push(action.payload)
    },
    aiWebSearchanswerAgreedDataSet(state, action){
      state.answerAgreedDataSet=action.payload
    },
    aiWebSearchdiscussionLogDataSet(state, action){
      state.discussionLogDataSet=action.payload
    },
    aiWebSearchcitationsDataSet(state, action){
      state.citationsDataSet=action.payload
    },
    aiWebSearchstantLoadingStatus(state,action){
      state.loadingStatus = action.payload
    },
    aiWebSearchstantQueStore(state,action){
      state.questore = action.payload
    },
    aiWebSearchstantFileStore(state,action){
      state.filestore = action.payload
    },
    aiWebSearchStope(state,action){
      state.stopApiCall = action.payload
    }
  }
})

export const {aiWebSearchStope,aiWebSearchstantFileStore, aiWebSearchdataAdd,aiWebSearchanswerAgreedDataSet,aiWebSearchdiscussionLogDataSet,aiWebSearchcitationsDataSet, aiWebSearchstantLoadingStatus ,aiWebSearchstantQueStore} = aiWebSearchData.actions
export default aiWebSearchData.reducer